import { LocationUtilities } from './utils';

const countryCodes = {
  EU: {
    countryName: 'Europe',
    countryList: ['AL', 'AD', 'AT', 'BY', 'BE', 'BA', 'IO', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'DE', 'GI', 'GR', 'GG', 'HU', 'IS', 'IE', 'IM', 'IT', 'JE', 'LV', 'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SJ', 'SE', 'CH', 'TR', 'UA', 'VA', 'AX', 'CZ', 'XK', 'MK', 'CS']
  },
  AU: {
    countryName: 'Australia',
    countryList: ['AQ', 'BV', 'TF', 'HM', 'AS', 'AU', 'CX', 'CK', 'FJ', 'PF', 'GU', 'KI', 'MH', 'FM', 'NR', 'NC', 'NZ', 'NU', 'NF', 'MP', 'PW', 'PG', 'WS', 'SB', 'TL', 'TK', 'TO', 'TV', 'VU', 'WF', 'GS', 'PN']
  },
  IN: {
    countryName: 'India',
    countryList: ['IN']
  },
  GB: {
    countryName: 'United Kingdom',
    countryList: ['GB']
  },
  ZA: {
    countryName: 'South Africa',
    countryList: ['ZA']
  }
};

const getCountryCode = (c) => {
  for (const i in countryCodes) {
    if (countryCodes[i].countryList.includes(c)) {
      return i;
    }
  }
  return 'US';
};

const updateUI = () => {
  $('.pricing-addon-options').each(function () {
    const $this = $(this);
    $this.find('.pricing-option').hide();
    LocationUtilities.onLocationReady(function (geoLocation, simpleGeoLocation) {
      const languageOption = $this.find(`.pricing-option[data-pricing-options="${$this.find('.pricing-options-dropdown').val()}"][data-pricing-currency="${getCountryCode(simpleGeoLocation.countryCode)}"]`);
      languageOption.show();
    });
  });
};

const init = () => {
  updateUI();
  $('.pricing-options-dropdown').on('change', function () {
    updateUI();
  });
};

export default { init };
